(function () {
  const observedSections = new WeakSet();
  const resizeObservers = new WeakMap();
  let resizeListenerAttached = false;

  function isMainProductSection(section) {
    if (!section) return false;
    if (section.matches('[data-c-main-product]')) return true;
    if (
      section.id &&
      section.id.indexOf('MainProduct-') === 0 &&
      section.hasAttribute('data-section')
    ) {
      return true;
    }
    return false;
  }

  function syncSection(section) {
    if (!isMainProductSection(section)) return;

    const tabContents = section.querySelector('.tab__contents');
    const formButtons = section.querySelector('.product-form__buttons');
    if (!formButtons) return;

    if (!tabContents || window.innerWidth < 750) {
      formButtons.style.width = '';
      formButtons.style.maxWidth = '';
      return;
    }

    const tabRect = tabContents.getBoundingClientRect();
    formButtons.style.width = '100%';
    formButtons.style.maxWidth = `${tabRect.width}px`;
  }

  function syncAllSections() {
    document
      .querySelectorAll('[data-c-main-product], [id^="MainProduct-"][data-section]')
      .forEach((section) => {
        syncSection(section);
      });
  }

  function observeSection(section) {
    if (!isMainProductSection(section) || observedSections.has(section)) return;

    const tabContents = section.querySelector('.tab__contents');
    if (tabContents && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(() => {
        syncSection(section);
      });
      observer.observe(tabContents);
      resizeObservers.set(section, observer);
    }

    observedSections.add(section);
    syncSection(section);
  }

  function initWithin(scope) {
    if (!scope) return;

    if (isMainProductSection(scope)) {
      observeSection(scope);
      return;
    }

    scope
      .querySelectorAll?.('[data-c-main-product], [id^="MainProduct-"][data-section]')
      .forEach((section) => {
        observeSection(section);
      });
  }

  function attachResizeListenerOnce() {
    if (resizeListenerAttached) return;
    window.addEventListener('resize', () => {
      syncAllSections();
    });
    resizeListenerAttached = true;
  }

  document.addEventListener('DOMContentLoaded', () => {
    initWithin(document);
    attachResizeListenerOnce();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initWithin(event.target);
    syncSection(event.target);
  });
})();
